import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-properties',
  templateUrl: './request-properties.component.html',
  styleUrls: ['./request-properties.component.css']
})
export class RequestPropertiesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/request-properties/request-properties.component.ts